import React from 'react'
import clsx from 'clsx'

import { ParagraphProps } from './ParagraphProps'
import { APP_COLOR, APP_FONT_SIZE } from '../AtomsGlobalProps'

import './ParagraphStyles.scss'


/**
 * Atom pozwalający na tworzenie paragrafów zgodnych z systemem designu.
 * 
 * @param {APP_COLOR} color - Kolor paragrafu zgodny z systemem designu.
 * @param {APP_FONT_SIZE} size  - Rozmiar paragrafu zgodny z systemem designu.
 * @param {String} html  - Dodatkowy HTML, który zostanie użyty w atrybucie dangerouslySetInnerHTML zamiast być użytym jako children w komponencie
 * @param {Boolean} bold - Czy pogrubiony
 * @param {Boolean} italic - Czy kursywą
 * @param {String} className - Dodatkowa klasa pozwalająca dodać customowe właściwości
 * @returns 
*/
const Paragraph = (props: ParagraphProps) => {
   const { color = APP_COLOR.PRIMARY, size = APP_FONT_SIZE.MEDIUM, html, bold, italic, align= 'justify', className, children, style, ...rest } = props
   const classes = clsx(className, 'app-paragraph', `app-paragraph--${color.toLowerCase()}`, `app-paragraph--${size.toLowerCase()}`)
   const styles = { fontWeight: bold ? 600 : 400, fontStyle: italic ? "italic" : "normal", textAlign: align, ...style }


   // Gdy przekazujemy propsa html - nie może on mieć dzieci, stąd musimy obsłużyć to inaczej
   if(html) {
      return (
         <p className={classes} style={styles} dangerouslySetInnerHTML={{ __html: props.html }} {...rest} />
      )
   }

   return (
      <p className={classes} style={styles} {...rest}>
         { children} 
      </p>
   )
}

export default Paragraph